export default __webpack_public_path__ + "c23c449d1d7a5c7ccf3a475d3de7f106.svg";